import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "connect-icon",
  "use": "connect-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"connect-icon\"><path fill=\"currentColor\" d=\"M19.972 4H4v2.244h13.728v11.481h-.002v2.244h2.246V4Z\" /><path fill=\"currentColor\" d=\"M18.324 4.05 5.251 17.122l1.587 1.586L19.91 5.637\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol